<template>
  <div v-if="Env.isMobile" ref="wakebutton" class="wake-button" mg-stat-click
       mg-stat-custom="label=icon&cont=&direct=app&addr=" mg-stat-mod="open_mgtv"
       @click="openApp">
    <img :src="WakeUp" alt="">
  </div>
</template>
<script>
import Env from 'utils/env';
import WakeUp from 'assets/img/wakeup.png';

export default {
  data() {
    // const iosDownUrl = 'https://itunes.apple.com/cn/app/mang-guotv-hu-nan-wei-shi/id629774477?mt=8';
    return {
      Env,
      WakeUp,
    };
  },
  methods: {
    openApp() {
      // 检查app是否打开
      /* function checkOpen(cb) {
        const clickTime = +(new Date());
        function check() {
          if (document.hidden || document.webkitHidden) {
            cb(1);
          } else {
            cb(0);
          }
        }
        // 启动间隔30ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
        let count = 0;
        const intHandle = setInterval(() => {
          count += 1;
          const elsTime = +(new Date()) - clickTime;
          if (count >= 100 || elsTime > 3000) {
            clearInterval(intHandle);
            check();
          }
        }, 30);
      } */
      const url = encodeURIComponent(window.location.href);
      const schemaLink = `imgotv://webview?url=${url}`;
      const universalLink = `https://msite.api.mgtv.com/download.html?type=2&content=${url}`;
      const androiDdownUrl = `http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&android_schema=${schemaLink}`;
      const { isIOS } = Env;
      /* if (isWeixin) {
        const str = isIOS ? 'safari' : '浏览器';
        this.$toast(`请点击右上角选择${str}打开`);
        return;
      } */
      window.location.href = isIOS ? universalLink : androiDdownUrl;
      /* checkOpen((isHidden) => {
        if (!isHidden) { // 3秒内如果没有唤起app就提示去安装
          window.location.href = isIOS ? iosDownUrl : androiDdownUrl;
        }
      }); */
    },
  },
};
</script>
<style lang="scss" scoped>
.wake-button {
  position: fixed;
  right: 20px;
  bottom: 240px;
  width: 81px;
  height: 120px;
  z-index: 1900;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>

